import { useCallback, useEffect, useState } from "react";
import { ClearLogsApi, FetchLogs, SelectedLog } from "../services/LogsService";

export const useLogList = (
  companyId,
  currentPage,
  perPage,
  action,
  search,
  category
) => {
  const [loading, setLoading] = useState(true);
  const [logsData, setLogsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const fetchLogsList = useCallback(async () => {
    setLoading(true);
    try {
      const response = await FetchLogs(
        `&company_id=${companyId}&page=${currentPage}&page_count=${perPage}&action=${action}&search=${search}&category=${category}`
      );
      setLogsData(response.history_details);
      setTotalCount(response.page_context.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [companyId, currentPage, action, search, perPage, category]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchLogsList();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchLogsList]);
  return {
    loading,
    refresh: fetchLogsList,
    logsData,
    totalCount,
  };
};

//Selected Logs

export const useFetchSelectedLog = (id) => {
  const [selectedLog, setSelectedLog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchLogById = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await SelectedLog(`?history_id=${id}`);
      console.log(response.selected_history_details[0]);
      setSelectedLog(response.selected_history_details[0]);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [id]);
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchLogById();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchLogById]);

  return { selectedLog, isLoading, error, refresh: fetchLogById };
};

// clearLogs

export const useClearLogs = () => {
  const [isLoading, setLoading] = useState(false);
  const ClearLogs = async (payload) => {
    try {
      await ClearLogsApi(payload);
      setLoading(true);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { isLoading, ClearLogs };
};
